import { MotifButton, MotifModal, MotifModalBody, MotifModalFooter } from '@ey-xd/motif-react'
import React from 'react'
import "./confirmationModal.scss";

type Props = {
  isVisible: boolean;
  setIsVisible: any;
  cancelBtnHandler: () => void;
  confirmBtnHandler: () => void;
  type?: number;
  heading?: string;
  message?: string;
  loading?: boolean;
  hideCancelButton?: boolean;
  confirmText?: string;
  cancelText?: string;
  confirmDisabled?: boolean;
  disableClose?: boolean;
};

export default function ConfirmationModal({
  isVisible,
  setIsVisible,
  cancelBtnHandler,
  confirmBtnHandler,
  type = 2,
  heading,
  message,
  loading = false,
  hideCancelButton = false,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmDisabled = false,
  disableClose = false,
}: Props) {
 
  return (
    <>
      <MotifModal
        onClose={() => {
          if (!disableClose) {
            cancelBtnHandler()
          }
        }}
        show={isVisible}
        size="md"
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
        className="confirmationModalWrapper"
      >
          <MotifModalBody>
            <span className="discard_heading">
              {heading || ""}
            </span>
            <div className="discard_message">
              {message || ""}
            </div>
          </MotifModalBody>
          <MotifModalFooter>
          {!hideCancelButton && (
            <MotifButton
              variant="secondary"
              className="discardBtnModal"
              onClick={cancelBtnHandler}
              loading={loading}
              disabled={loading}
            >{cancelText}</MotifButton>
          )}
             <MotifButton
              variant="primary"
              className="discardBtnModal"
              onClick={confirmBtnHandler}
              loading={loading}
              disabled={confirmDisabled}
            >{confirmText}</MotifButton>
          </MotifModalFooter>
      </MotifModal>
    </>
  );
}

